'use client';

import { useContext, useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { PricingContext } from '@/app/services/providers/contexts/pricing-context';
import { UserContextV2 } from '@/app/services/providers/contexts/user-context';
import { analyticsEvent, createGAEcommerceObject, push } from '@/services/analytics';
export function ViewItemAnalytics() {
  const {
    userPlan
  } = useContext(UserContextV2);
  const {
    model,
    currency,
    billingCycle
  } = useContext(PricingContext);
  useEffect(() => {
    if (!userPlan) {
      // Don't trigger ecommerce events without a user
      // They need to sign up first
      return;
    }
    if (userPlan === 'business') {
      // Don't trigger for business, they can't purchase
      return;
    }
    try {
      const upgradePath = userPlan === 'pro' ? 'teams' : 'pro';
      const price = model[currency][upgradePath][billingCycle];
      push({
        ecommerce: null
      });
      analyticsEvent('view_item', {
        ecommerce: createGAEcommerceObject(upgradePath === 'teams' ? 'business' : 'pro', currency, price, {
          item_variant: billingCycle
        })
      });
    } catch (err) {
      Sentry.captureException(err);
    }
  }, [currency, model, userPlan, billingCycle]);
  return undefined;
}